import { render, staticRenderFns } from "./OptionsEdit.vue?vue&type=template&id=01d63a63"
import script from "./OptionsEdit.vue?vue&type=script&lang=ts"
export * from "./OptionsEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports